import React, { useCallback } from 'react';
import './index.scss'
import "newcar-ui/output/index.css";
// import {
//     BaseModal,
// } from "newcar-ui/output/cjs/components/AskpricePublicModal";
import { tools } from 'newcar-ui/output/cjs/utils';

const RecommendCarList = (props) => {
    const { data: { list } } = props
    const showCarPricePop = useCallback((item) => {
        tools.sendClickStatistics_wmda(343, {
            lineID: item.lineId,
            actionType: '24biae-toprice-click'
        })
        if (typeof props.onPriceClick !== 'undefined') {
            props.onPriceClick({
                lineId: item.lineId
            })
        }
    }, [])

    const onItemClick = useCallback((item) => {
        if (typeof props.onItemClick !== 'undefined') {
            props.onItemClick(item)
        }
    }, [])
    return (
        <div className='recommenCarList'>
            {list?.map((item, index) => {
                return (
                    <div className='list-item' key={index} onClick={() => onItemClick(item)}>
                        <img className="list-item-cover" src={item?.pic} />
                        <div className='list-item-content'>
                            <div className='item-title'>{item?.title}</div>
                            <div className='item-description'>{item?.desc}</div>
                            <div className='item-askprice'>
                                <button className='btnPrice' onClick={(e) => { e.stopPropagation(); showCarPricePop(item) }}>获取底价</button>
                            </div>
                        </div>
                    </div>
                )
            })}
            <div className="nomore">更多内容，敬请期待!</div>
        </div>
    )
}

export default RecommendCarList;